import { useQuery } from '@tanstack/react-query'
import { SEEDBOT_BASE_URL } from './useSeedbotHealth'

export interface WalletPosition {
  walletAddress: string
  walletType: 'launcher' | 'bundle'
  walletIndex: number
  tokenAccount: string
  amount: string
  amountFormatted: string
}

export interface PositionData {
  mint: string
  platform: 'dextoro' | 'pumpfun' | 'unknown'
  name: string | null
  ticker: string | null
  totalAmount: string
  totalAmountFormatted: string
  wallets: WalletPosition[]
}

export function usePositions() {
  return useQuery({
    queryKey: ['positions'],
    queryFn: async (): Promise<{ positions: PositionData[] }> => {
      const res = await fetch(`${SEEDBOT_BASE_URL}/positions`)
      if (!res.ok) throw new Error(`Positions endpoint returned ${res.status}`)
      return res.json()
    },
    staleTime: 30_000,
    refetchInterval: 60_000,
  })
}
